import { ControlledSelectField, ControlledTextField } from 'components/Form';
import { CostGroupEnum } from 'gql/graphql';

import type { UseControllerProps } from 'react-hook-form';
import { useWatch } from 'react-hook-form';

const ActKC2CostGroupLabels: Record<CostGroupEnum, string> = {
    [CostGroupEnum.Cmr]: 'СМР (Строительно-монтажные работы)',
    [CostGroupEnum.Others]: 'Прочие',
};

export const getActKC2CostGroupLabel = (code: CostGroupEnum) => ActKC2CostGroupLabels[code];

export const getActKC2CostGroupItem = (id: CostGroupEnum) => ({
    id,
    label: getActKC2CostGroupLabel(id),
});

const items = [getActKC2CostGroupItem(CostGroupEnum.Cmr), getActKC2CostGroupItem(CostGroupEnum.Others)];

export const ActKC2CostGroupField = ({
    name,
    control,
    readOnly,
    rules,
    required,
}: UseControllerProps & { readOnly?: boolean; required?: boolean }) => {
    const costGroup = useWatch({
        control,
        name,
    });

    const value = getActKC2CostGroupLabel(costGroup);

    return (
        <>
            {readOnly && (
                <ControlledTextField
                    name={name}
                    label="Группа затрат"
                    control={control}
                    type="text"
                    view="clear"
                    value={value}
                    readOnly
                />
            )}
            {!readOnly && (
                <ControlledSelectField
                    name={name}
                    label="Группа затрат"
                    control={control}
                    items={items}
                    rules={rules}
                    required={required}
                />
            )}
        </>
    );
};

ActKC2CostGroupField.displayName = 'ActKC2CostGroupField';
